module.exports = __webpack_public_path__ + "main/assets/public/event/icon-pin.8d7d49fa80c09a79.svg";